module.exports = __webpack_public_path__ + "img/DIF_LOGO_flerfarvede_ringe.396cf204.png";